/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { MissingTrailerFragmentDoc } from '../../../../marketplace/pages/shippers/components/ShipperTrailers/graphql/MissingTrailerFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IMissingTrailersQueryVariables = Types.Exact<{
  after?: Types.Maybe<Types.Scalars['String']>
  before?: Types.Maybe<Types.Scalars['String']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
  sortBy?: Types.Maybe<Types.Scalars['String']>
  sortDirection?: Types.Maybe<Types.ISortOrderEnum>
  shipmentIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  states?: Types.Maybe<Array<Types.IShipmentStates> | Types.IShipmentStates>
  dropTrailer?: Types.Maybe<Types.Scalars['Boolean']>
  hasTrailer?: Types.Maybe<Types.Scalars['Boolean']>
  shipperFacilityUuids?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  shipperApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  carrierApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  pickupDate?: Types.Maybe<Array<Types.Scalars['ISO8601Date']> | Types.Scalars['ISO8601Date']>
  deliveryDate?: Types.Maybe<Array<Types.Scalars['ISO8601Date']> | Types.Scalars['ISO8601Date']>
}>

export type IMissingTrailersQuery = { __typename?: 'Query' } & {
  shipments: { __typename?: 'ShipmentConnection' } & Pick<
    Types.IShipmentConnection,
    'totalCount'
  > & {
      nodes?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'Shipment' } & Pick<
              Types.IShipment,
              'id' | 'state' | 'hasClaims' | 'shipperRateType' | 'currentStopIndex' | 'updatedAt'
            > & {
                carrierApplication?: Types.Maybe<
                  { __typename?: 'CarrierApplication' } & Pick<
                    Types.ICarrierApplication,
                    'id' | 'dotNumber' | 'mcNumber' | 'name' | 'state' | 'fmcsaRating' | 'isTrusted'
                  >
                >
                characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
                  Types.IShipmentCharacteristics,
                  | 'hazmat'
                  | 'hot'
                  | 'mustGo'
                  | 'backhaulEligible'
                  | 'rolloverCount'
                  | 'sameDaySpot'
                  | 'bounceCount'
                >
                firstPickup: { __typename?: 'ShipmentStop' } & Pick<
                  Types.IShipmentStop,
                  'id' | 'city' | 'stateCode' | 'dropTrailer'
                >
                lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
                  Types.IShipmentStop,
                  'id' | 'city' | 'stateCode' | 'dropTrailer'
                >
                stops: Array<
                  { __typename?: 'ShipmentStop' } & Pick<
                    Types.IShipmentStop,
                    'id' | 'arrivedAt' | 'stopSequence' | 'stopType'
                  > & {
                      appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                        Types.IShipmentStopAppointment,
                        'id' | 'status' | 'startAt' | 'endAt' | 'timezone'
                      >
                    }
                >
                equipment: { __typename?: 'Equipment' } & Pick<
                  Types.IEquipment,
                  'id' | 'name' | 'parentKey'
                >
                shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                  Types.IShipperApplication,
                  'id' | 'name'
                >
              }
          >
        >
      >
      pageInfo: { __typename?: 'PageInfo' } & Pick<Types.IPageInfo, 'endCursor' | 'startCursor'>
    }
}

export const MissingTrailersDocument = gql`
  query MissingTrailers(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: String
    $sortDirection: SortOrderEnum = DESC
    $shipmentIds: [ID!]
    $states: [ShipmentStates!]
    $dropTrailer: Boolean
    $hasTrailer: Boolean
    $shipperFacilityUuids: [ID!]
    $shipperApplicationIds: [ID!]
    $carrierApplicationIds: [ID!]
    $pickupDate: [ISO8601Date!]
    $deliveryDate: [ISO8601Date!]
  ) {
    shipments(
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
      sortDirection: $sortDirection
      ids: $shipmentIds
      state: $states
      dropTrailer: $dropTrailer
      hasTrailer: $hasTrailer
      shipperFacilityUuids: $shipperFacilityUuids
      shipperApplicationIds: $shipperApplicationIds
      carrierApplicationIds: $carrierApplicationIds
      pickupDates: $pickupDate
      deliveryDates: $deliveryDate
    ) {
      nodes {
        ...MissingTrailer
      }
      totalCount
      pageInfo {
        endCursor
        startCursor
      }
    }
  }
  ${MissingTrailerFragmentDoc}
`

/**
 * __useMissingTrailersQuery__
 *
 * To run a query within a React component, call `useMissingTrailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissingTrailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissingTrailersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      shipmentIds: // value for 'shipmentIds'
 *      states: // value for 'states'
 *      dropTrailer: // value for 'dropTrailer'
 *      hasTrailer: // value for 'hasTrailer'
 *      shipperFacilityUuids: // value for 'shipperFacilityUuids'
 *      shipperApplicationIds: // value for 'shipperApplicationIds'
 *      carrierApplicationIds: // value for 'carrierApplicationIds'
 *      pickupDate: // value for 'pickupDate'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useMissingTrailersQuery(
  baseOptions?: Apollo.QueryHookOptions<IMissingTrailersQuery, IMissingTrailersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IMissingTrailersQuery, IMissingTrailersQueryVariables>(
    MissingTrailersDocument,
    options
  )
}
export function useMissingTrailersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IMissingTrailersQuery, IMissingTrailersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IMissingTrailersQuery, IMissingTrailersQueryVariables>(
    MissingTrailersDocument,
    options
  )
}
export type MissingTrailersQueryHookResult = ReturnType<typeof useMissingTrailersQuery>
export type MissingTrailersLazyQueryHookResult = ReturnType<typeof useMissingTrailersLazyQuery>
export type MissingTrailersQueryResult = Apollo.QueryResult<
  IMissingTrailersQuery,
  IMissingTrailersQueryVariables
>
